import { FC } from 'react';

import { ProfileReportsRowSkeleton } from './ProfileReportsRowSkeleton';

import { Tag } from '@/components/atoms';
import { DirectReportsData } from '@/types/account-settings';

import { TableCell, TableRow } from '../Table/Table';

type ProfileReportsRowProps = {
  rowData: DirectReportsData;
  isLoading?: boolean;
};

export const ProfileReportsRow: FC<ProfileReportsRowProps> = ({ rowData, isLoading }) => {
  const { profileImageUrl, name, jobTitle, department, location, tenure } = rowData;
  if (isLoading) {
    return <ProfileReportsRowSkeleton />;
  }
  return (
    <TableRow>
      <TableCell>
        <div className="flex items-center gap-2">
          <img
            src={profileImageUrl}
            alt={name}
            width={32}
            height={32}
            className="rounded-full object-cover"
          />
          <div>
            <div className="flex items-center gap-1.5 mb-1">
              <p className="text-body-14-semibold text-custom-warm-grey-950">{name}</p>
            </div>
            <p className="text-body-12-regular text-custom-warm-grey-600">{jobTitle}</p>
          </div>
        </div>
      </TableCell>
      <TableCell>
        <Tag label={department} size="regular" color="grey" />
      </TableCell>
      <TableCell>
        <p>{location ?? '—'}</p>
      </TableCell>
      <TableCell>
        <p>{tenure}</p>
      </TableCell>
    </TableRow>
  );
};
